import { render, staticRenderFns } from "./ResultFormSeCustoms.vue?vue&type=template&id=43d272f0&scoped=true&"
import script from "./ResultFormSeCustoms.vue?vue&type=script&lang=js&"
export * from "./ResultFormSeCustoms.vue?vue&type=script&lang=js&"
import style0 from "./ResultFormSeCustoms.vue?vue&type=style&index=0&id=43d272f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43d272f0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('43d272f0')) {
      api.createRecord('43d272f0', component.options)
    } else {
      api.reload('43d272f0', component.options)
    }
    module.hot.accept("./ResultFormSeCustoms.vue?vue&type=template&id=43d272f0&scoped=true&", function () {
      api.rerender('43d272f0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/ToolAssistant/ocr/components/ResultFormSeCustoms.vue"
export default component.exports